import gql from "graphql-tag"

const GET_DISCOUNT_EXTERNAL_RULE = gql`
  query getDiscountExternalRule($id: ID!) {
    getDiscountExternalRule(id: $id) {
      id
      name
      logicRules {
        if
        do
      }
      isActive
      isStackable
      isExclusive
      applyLast
      sortOrder
      conditions {
        type
        id
        triggerQuantity
        identifiers
        thresholds {
          currencyCode
          units
        }
        itemRule {
          tagConditions {
            mode
            key
            values
          }
          excludeDiscountedPrices
          excludeFullPrices
        }
      }
      outcomes {
        type
        id
        subOutcomes {
          triggerQuantity
          discountQuantity
          discountValue {
            type
            percentage
            fixedDiscounts {
              currencyCode
              units
            }
          }
        }
        discountValue {
          type
          percentage
          fixedDiscounts {
            currencyCode
            units
          }
        }
        discountItemRule {
          tagConditions {
            mode
            key
            values
          }
          excludeDiscountedPrices
          excludeFullPrices
        }
        triggerItemRule {
          tagConditions {
            mode
            key
            values
          }
          excludeDiscountedPrices
          excludeFullPrices
        }
        triggerQuantity
        discountQuantity
        gifts {
          productVariantId
          quantity
        }
        combineItemDiscount
        isRecurrent
        shippingTags
      }
      validDateRange {
        from
        to
      }
    }
  }
`

export default GET_DISCOUNT_EXTERNAL_RULE
